import { Icon, IconButton, Menu, MenuButton, MenuItem, MenuList, Portal } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import { useMemo } from 'react';
import { BiMenu } from 'react-icons/bi';
import { RiBook2Line, RiStackLine } from 'react-icons/ri';

import { PortfolioDrawer, usePortfolioDrawerControls } from '@/cip/Portfolio/PortfolioDrawer/PortfolioDrawer';

import { Restriction } from '../_openapi/portfolio-optimizer';
import { AssetDrawer, useAssetDrawerControls } from '../Asset/AssetDrawer/AssetDrawer';

const columnHelper = createColumnHelper<Restriction>();

export const useRestrictionRowActions = () => {
    const { viewPortfolio, ...portfolioDrawerProps } = usePortfolioDrawerControls();
    const { viewAsset, ...assetDrawerProps } = useAssetDrawerControls();

    const restrictionActionColumn = useMemo(
        () =>
            columnHelper.display({
                id: 'contextMenu',
                cell: ({ row }) => {
                    return (
                        <Menu isLazy>
                            <MenuButton
                                size="xs"
                                as={IconButton}
                                aria-label="Options"
                                icon={<Icon boxSize={3} as={BiMenu} />}
                                w="20px"
                                minW="20px"
                                h="20px"
                                variant="outline"
                                borderRadius="sm"
                            />
                            <Portal>
                                <MenuList>
                                    <MenuItem
                                        icon={<Icon boxSize={4} as={RiBook2Line} />}
                                        onClick={() => row.original.pId && viewPortfolio(row.original.pId)}
                                        isDisabled={!row.original.pId}
                                    >
                                        Portfolio details
                                    </MenuItem>
                                    <MenuItem
                                        icon={<Icon boxSize={4} as={RiStackLine} />}
                                        onClick={() => viewAsset(row.original.sId)}
                                    >
                                        Security details
                                    </MenuItem>
                                </MenuList>
                            </Portal>
                        </Menu>
                    );
                },
                enableSorting: false,
                meta: {
                    isDisplayCol: true,
                    isSticky: true,
                },
            }),
        [viewAsset, viewPortfolio],
    );

    return {
        restrictionActionColumn,
        drawers: (
            <>
                <PortfolioDrawer {...portfolioDrawerProps} />
                <AssetDrawer {...assetDrawerProps} />
            </>
        ),
    };
};
